"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowAdapter = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var index_1 = require("./index");
var dom_1 = require("./dom");
var WindowAdapter = /** @class */ (function () {
    function WindowAdapter() {
        this.statusWindow = new rxjs_1.BehaviorSubject(null);
    }
    WindowAdapter.prototype.setWebAdapter = function (data) {
        dom_1.atWindow()['webAdapter'] = data;
        this.statusWindow.next(data);
    };
    WindowAdapter.prototype.getProperty = function () {
        return this.statusWindow.asObservable().pipe(operators_1.map(function () { return dom_1.atWindow()['webAdapter']; }), operators_1.filter(function (e) { return !index_1.isNullOrUndefined(e); }));
    };
    WindowAdapter.prototype.setProps = function (key, value) {
        var _a;
        var main = dom_1.atWindow()['webAdapter'];
        var currentProps = __assign(__assign({}, main), { props: __assign(__assign({}, main.props), (_a = {}, _a[key] = value, _a)) });
        this.setWebAdapter(currentProps);
    };
    WindowAdapter.prototype.setWebComponent = function (webComponent) {
        var main = dom_1.atWindow()['webAdapter'];
        var currentComponent = __assign(__assign({}, main), { webComponents: __spreadArrays(main.webComponents, [webComponent]) });
        this.setWebAdapter(currentComponent);
    };
    return WindowAdapter;
}());
exports.WindowAdapter = WindowAdapter;
